import axios from 'axios'
import {AuthModel, UserModel} from './_models'

const API_URL = process.env.REACT_APP_API_URL

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/user/verify_token`
export const LOGIN_URL = `${API_URL}/auth/login`
export const RESET_PASSWORD_URL = `${API_URL}/register/reset_password`
export const CHECK_RESET_URL = `${API_URL}/register/check_reset_user`
export const REGISTER_URL = `${API_URL}/register/register_new_user`
export const VERIFY_EMAIL_URL = `${API_URL}/register/update_verify_date`
export const UPDATE_PASSWORD_URL = `${API_URL}/register/update_password`
export const REQUEST_PASSWORD_URL = `${API_URL}/forgot_password`
export const GET_UPDATE_PASSWORD_KEY_URL = `${API_URL}/user/encoded_user_id`
export const UPDATE_USER_INFO_URL = `${API_URL}/register/update_user`


export function getResetPasswordKey() {
  console.log("UPDATE_PASSWORD_URL: "+GET_UPDATE_PASSWORD_KEY_URL)
  return axios.post(GET_UPDATE_PASSWORD_KEY_URL, {})
}

// Server should return AuthModel
export function login(email: string, password: string, user:string) {
  console.log("user >>>>>>>> "+user)
  return axios.post<AuthModel>(LOGIN_URL, {
    email,
    password,
    user
  })
}

// Server should return AuthModel
export function register(
  email: string,
  firstname: string,
  lastname: string,
  password: string,
  password_confirmation: string
) {
  console.log("REGISTER_URL: "+REGISTER_URL)
  return axios.post(REGISTER_URL, {
    email,
    first_name: firstname,
    last_name: lastname,
    password,
    password_confirmation,
  })
}

// Server should return AuthModel
export function update_account(
  userID: number | undefined,
  firstname: string | undefined,
  lastname: string | undefined,
  email: string | undefined
) {
  return axios.post(UPDATE_USER_INFO_URL, {
    user_id: userID,
    first_name: firstname,
    last_name: lastname,
    email,
  })
}

export function updatePassword(
  encoded_user_id: string | null,
  password: string
) {
  console.log("UPDATE_PASSWORD_URL: "+UPDATE_PASSWORD_URL)
  return axios.post(UPDATE_PASSWORD_URL, {
    encoded_user_id,
    password
  })
}

export function resetPassword(
  encoded_user_id: string | null,
  password: string,
  password_confirmation: string
) {
  console.log("REGISTER_URL: "+REGISTER_URL)
  return axios.post(REGISTER_URL, {
    encoded_user_id,
    password,
    password_confirmation,
  })
}

export function forgetPassword(
  email: string
) {
  console.log("RESET_PASSWORD_URL: "+RESET_PASSWORD_URL)
  return axios.post(RESET_PASSWORD_URL, {
    email
  })
}

export function verfyEmail(
  encoded_user_id: string | null
) {
  return axios.post(VERIFY_EMAIL_URL, {
    user_id: encoded_user_id
  })
}

export function checkResetUser(
  encoded_user_id: string | null
) {
  //console.log("encoded_user_id: "+encoded_user_id);
  return axios.post(CHECK_RESET_URL, {
    user_id: encoded_user_id
  })
}

export function requestPassword(email: string) {
  return axios.post<{result: boolean}>(REQUEST_PASSWORD_URL, {
    email,
  })
}

export function getUserByToken(token: string) {
  console.log("token: "+token)
  return axios.post<UserModel>(GET_USER_BY_ACCESSTOKEN_URL, {
    api_token: token
  })
}
